import _ from 'lodash';

export const join = ({
  part1,
  part2,
  separator,
}: {
  part1: string,
  part2: string,
  separator?: ?string,
}) => {
  if (_.isNil(part1) && _.isNil(part2)) return '';

  if (_.isNil(part1)) return part2;
  if (_.isNil(part2)) return part1;
  return `${part1} ${separator || '-'} ${part2}`;
};

export const toLocaleString = (value) => String(value.toLocaleString());

export const existsAndNotEmptyString = (value) => !!value && value !== '';
